// extracted by mini-css-extract-plugin
export default {"PoweredByBlock":"PoweredBy-module__PoweredByBlock__ECOxb"};